import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

interface CreatePuzzlePayload {
  meetingId: string;
  occurenceId: string;
  moveList: string;
  moveCount: number;
  startingFEN: string;
  puzzleName: string;
  orientation: string;
  puzzleTime: string;
}

interface CreatePuzzleResponse {
  message: string;
}

export default function useCreatePuzzleApi(
  handleOnSuccess?: (data: CreatePuzzleResponse) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<CreatePuzzleResponse, unknown, CreatePuzzlePayload> {
  return useMutation<CreatePuzzleResponse, unknown, CreatePuzzlePayload>(
    async (payload: CreatePuzzlePayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/create_puzzle/',
        payload,
      );
      console.log('Create Puzzle in Classroom = ', response.data);
      return response.data;
    },
    {
      onSuccess: (data: CreatePuzzleResponse) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to Create Classroom Puzzle:', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
